'use client';

import React__default from 'react';
import { useCalendar } from '../context/calendar.js';
import { ECalendarType } from '../types.js';
import MonthPanel from './panel/monthPanel.js';
import YearPanel from './panel/yearPanel.js';
import DecadePanel from './panel/decadePanel.js';
import CombinePanel from './combinePanel/index.js';

function CalendarPanel() {
    var _a = useCalendar(), currentDate = _a.currentDate, calendarType = _a.calendarType;
    var renderPanel = function () {
        switch (calendarType) {
            case ECalendarType.year:
                return React__default.createElement(YearPanel, { currentDate: currentDate });
            case ECalendarType.decade:
                return React__default.createElement(DecadePanel, { currentDate: currentDate });
            case ECalendarType.combine:
            case ECalendarType.combineMonthAndYear:
                return React__default.createElement(CombinePanel, null);
            default:
                return React__default.createElement(MonthPanel, { currentDate: currentDate });
        }
    };
    return renderPanel();
}

export { CalendarPanel as default };
//# sourceMappingURL=panel.js.map
